import React from 'react';
import { Divider } from '../../common/atoms';
import { Lock, Tick } from '../../../assets/images';

const UtilizationCard = ({ sectionTitle, image, sectionSubtitle, points, toggleHelp }) => {
  return (
    <div
      className='flex flex-col bg-white border overflow-hidden rounded-md w-full h-auto'
      style={{ background: '#FFFCF3' }}
    >
      <div className='bg-yellow-100 p-3 pl-12  h-24 flex flex-row items-center'>
        <img src={Lock} className='mr-5' width='70' height='70' alt='lock_image' />
        <div className='text-gray-900 text-2xl font-bold'>{sectionTitle}</div>
      </div>
      <div className='bg-white pt-12 pl-12 pr-32 flex flex-row'>
        <img src={image} className='mr-16' style={{ width: 300 }} alt='image1' />
        <div className='mt-2 flex-col'>
          <div className='text-gray-900 font-semibold text-xl mb-6 leading-none'>{sectionSubtitle}:</div>
          {points.map((point, key) => {
            return (
              <div className='flex flex-row text-base text-gray-800 text-black mb-6' key={`${point}`+ key}>
                <img src={Tick} className='mr-3 mt-1' style={{ height: 14, width: 14 }} alt='tick' />
                {point}
              </div>
            );
          })}
          {['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) ? (
            <div>
              <Divider classes='w-full' />
              <p className='mt-6 ml-6 text-base text-gray-700 font-semibold italic'>
                The HR will reach out to you in case they want to avail this service for their organization
              </p>
            </div>
          ) : (
            <div>
              <div className='mt-8 ml-6 text-base text-gray-800 leading-none'>
                👇 Reach out to your Customer Success Manager to learn more
              </div>
              <div className='mt-5 ml-6 text-gray-700'>
                <button
                  type='button'
                  onClick={toggleHelp}
                  className='inline-flex items-center px-6 py-2 border-none text-base font-semibold rounded text-white bg-blue-500 hover:bg-blue-600 focus:outline-none'
                >
                  Send a request
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UtilizationCard;
